import { useState, useEffect } from "react";
import { usePools } from "../hooks/usePools";
import { PayoutHistory } from "../components/PayoutHistory";
import { PoolSwitcher } from "../components/PoolSwitcher";
import { PageShell } from "../components/EmptyStateWrapper";
import { LoadingIndicator, ShellContentFrame, ShellStatePane } from "../components/ShellContentFrame";
import { api } from "../lib/api";

export function PayoutHistoryPage() {
    const { pools, activePool, activePoolId, selectPool, loading } = usePools();
    const [payouts, setPayouts] = useState([]);
    const [pLoading, setPLoading] = useState(false);

    useEffect(() => {
        let m = true;
        (async () => {
            if (!activePool?.id) { setPayouts([]); return; }
            setPLoading(true);
            try {
                const { data } = await api.get(`/pools/${activePool.id}/payouts`);
                if (m) setPayouts(data.payouts || []);
            } finally { if (m) setPLoading(false); }
        })();
        return () => { m = false; };
    }, [activePool?.id]);

    const showLoadingReserve = loading;
    const showNoPool = !loading && !activePool;
    const showContent = !loading && !!activePool;

    return (
        <PageShell flow>
            <ShellContentFrame
                loading={loading}
                loadingLabel="Loading pools…"
                layout="flow"
                minHeight="min-h-[28rem]"
                testId="payout-history-frame"
                loadingTestId="payout-history-loading"
            >
                <ShellStatePane active={showLoadingReserve} layout="flow" testId="payout-history-loading-reserve">
                    <div className="min-h-[28rem]" aria-hidden="true" />
                </ShellStatePane>

                <ShellStatePane active={showNoPool} layout="flow" testId="payout-history-empty-pane">
                    <div className="min-h-[28rem] flex items-center justify-center text-white/40" data-testid="payout-history-no-pool">
                        No pool found.
                    </div>
                </ShellStatePane>

                <ShellStatePane active={showContent} layout="flow" testId="payout-history-content-pane">
                    {activePool ? (
                    <div className="space-y-6">
                        <div>
                            <p className="label-eyebrow">Ledger</p>
                            <h1 className="font-heading text-3xl sm:text-4xl tracking-tight mt-1">Payout history</h1>
                            <p className="text-white/50 mt-1.5">Append-only record of every disbursement. Export anytime for accounting.</p>
                        </div>
                        <div className="flex items-center gap-3">
                            <PoolSwitcher pools={pools} activeId={activePoolId} onSelect={selectPool} />
                        </div>
                        <div className="relative min-h-[16rem]">
                            <div className={pLoading ? "pointer-events-none invisible" : ""} aria-hidden={pLoading}>
                                <PayoutHistory payouts={payouts} poolId={activePool.id} poolName={activePool.name} />
                            </div>
                            {pLoading && (
                                <div className="absolute inset-0 grid place-items-center">
                                    <LoadingIndicator label="Loading payouts…" testId="payout-history-payouts-loading" />
                                </div>
                            )}
                        </div>
                    </div>
                    ) : null}
                </ShellStatePane>
            </ShellContentFrame>
        </PageShell>
    );
}
